import Wordpress, { wordPressStaticProps } from "pagecomponents/Wordpress";
import WordpressLayout from "@layouts/Wordpress";
import Head from "next/head";

export default function About({html, seo, script }) {
    return <Wordpress html={html} seo={seo} script={script} gblock />
}

export async function getStaticProps() {
    return await (wordPressStaticProps(1759))();
    // 1651
}

About.getLayout = (page) => (
    <WordpressLayout>
        <Head>
        <style
            id="holderStyle"
            dangerouslySetInnerHTML={{
                __html: `
                .wp-block-social-links:not(.is-style-logos-only) .wp-social-link {
                    margin: 0 9px;
                }

                .wp-block-genesis-blocks-gb-columns.gb-slate-team.gb-layout-team-1.gb-layout-columns-1.one-column.has-ast-global-color-5-background-color.gb-has-custom-text-color.gb-columns-center.alignfull {
                    padding-top: 1em !important;
                }                
                `,
            }}/>            
        </Head>
        {page}
    </WordpressLayout>
)